



















































































import Vue from "vue";
import { Carousel, Slide } from "vue-carousel";

import BannerPartner from "@/components/common/BannerPartner.vue";
import IconArrowLeft from "@/components/icons/IconArrowLeft.vue";
import IconArrowRight from "@/components/icons/IconArrowRight.vue";
import IconPaginationAnimation from "@/components/icons/IconPaginationAnimation.vue";
import TitleH2 from "@/components/common/TitleH2.vue";

import { IState } from "./interfaces";

export default Vue.extend({
  name: "SliderIcon",
  props: {
    images: { type: Array, default: () => [] },
    title: String,
    action: Function,
  },
  components: {
    Carousel,
    Slide,
    BannerPartner,
    IconArrowLeft,
    IconArrowRight,
    IconPaginationAnimation,
    TitleH2,
  },
  data(): IState {
    return {
      current: 0,
      interval: 5000,
      auto: undefined,
      options: {
        paginationEnabled: false,
        perPage: 4,
        loop: false,
        autoplay: false,
      },
    };
  },
  computed: {
    pagesCount(): number {
      return this.images.length + 1 / this.options.perPage - 1;
    },
    slidePagination(): number {
      return Math.ceil((this.images.length + 1) / this.options.perPage);
    },
  },
  mounted() {
    this.resetTimer();
  },
  methods: {
    nav(index: number) {
      this.resetTimer();
      const length = this.slidePagination - 1;
      if (index < 0) {
        if (this.current === 0) {
          this.current = length;
        } else {
          this.current--;
        }
      }
      if (index > 0) {
        if (this.current === length) {
          this.current = 0;
        } else {
          this.current++;
        }
      }
    },
    pagination(index: number) {
      this.resetTimer();
      this.current = index;
    },
    resetTimer() {
      window.clearInterval(this.auto);
      this.auto = window.setInterval(() => {
        this.nav(1);
      }, this.interval);
    },
    stopTimer() {
      window.clearInterval(this.auto);
    },
  },
});
